module.exports = __webpack_public_path__ + "img/bill_v2.5ea07483.png";